/* Vornom redesign (D1 = b): collection and search pages (sections/vor-collection, sections/vor-search),
   ported from UPP's assets/vor-collection.js.
   - Filters, sort and applied-filter links refresh the [data-vor-col-swap] parts from ?section_id= and push the URL.
   - The drawer form is the one source of truth; desktop dropdown inputs mirror drawer inputs (data-for).
   - "Daha fazla ürün göster" is a real ?page=N link; JS appends that page's cards. The pages loaded and the scroll
     position live in history.state, so Back from a product puts the visitor where they were.
   - Events (filter_apply, view_item_list, select_item) come from assets/vor-events.js through the data-vor-filter /
     data-vor-item-id attributes; no gtag call here. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__vorCol) return;
    root.__vorCol = true;
    if (!root.querySelector('[data-vor-col-form]')) return; // e.g. a search with no results

    var sid = root.getAttribute('data-section-id');
    var drawer = root.querySelector('[data-vor-col-drawer]');
    var form = root.querySelector('[data-vor-col-form]');
    var bar = root.querySelector('[data-vor-col-bar]');
    var ctrl = null;
    var pending = null;
    var opener = null;
    var gen = 0; // bumped by every filter/sort refresh; page appends from an older one are dropped (review 2026-10-18)

    /* ---------- sticky offset under the sticky site header ---------- */
    var hdr = document.querySelector('.vor-hdr-section') || document.querySelector('[data-section-type="header"]');
    function setTop() {
      var h = 0;
      if (hdr && getComputedStyle(hdr).position === 'sticky') h = Math.round(hdr.getBoundingClientRect().height);
      root.style.setProperty('--vor-col-top', h + 'px');
    }
    setTop();
    if (hdr && window.ResizeObserver) new ResizeObserver(setTop).observe(hdr);

    /* ---------- fetching and swapping ---------- */
    function sectionUrl(url) {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', sid);
      return u.toString();
    }

    function getDoc(url, signal) {
      return fetch(sectionUrl(url), { signal: signal, credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
    }

    function swap(doc) {
      var act = document.activeElement && root.contains(document.activeElement) ? document.activeElement : null;
      var focusId = act ? act.id : '';
      // A price field the visitor is still typing in keeps its text (review 2026-10-18)
      var typed = act && act.type === 'number' ? act.value : null;
      // Removed chips and "Tümünü temizle" have no id: remember where they sat to put focus back nearby
      var actRegion = act && act.closest('[data-vor-col-swap]');
      var actKey = actRegion ? actRegion.getAttribute('data-vor-col-swap') : '';
      var actChip = actRegion && act.closest('.vor-col__applied') ? Array.prototype.indexOf.call(actRegion.querySelectorAll('.vor-col__applied a'), act) : -1;
      var openIds = [];
      root.querySelectorAll('details[id]').forEach(function (d) { openIds.push([d.id, d.open]); });

      root.querySelectorAll('[data-vor-col-swap]').forEach(function (el) {
        var key = el.getAttribute('data-vor-col-swap');
        var src = doc.querySelector('[data-vor-col-swap="' + key + '"]');
        if (src) el.innerHTML = src.innerHTML;
      });

      openIds.forEach(function (p) {
        var d = document.getElementById(p[0]);
        if (d && root.contains(d)) d.open = p[1];
      });
      root.classList.remove('is-extended');
      cleanLinks();
      var f = focusId ? document.getElementById(focusId) : null;
      if (f) {
        if (typed !== null && f.type === 'number' && f.value !== typed) {
          f.value = typed;
          f.__vorTyped = true; // not applied yet: focusout sends it if no change event does
        }
        f.focus({ preventScroll: true });
      } else if (act && !document.body.contains(act) && actKey) {
        focusNear(actKey, actChip);
      }
    }

    // Focus the chip that took the removed one's place, else "Tümünü temizle"; with no chips left,
    // the drawer title or the results (review 2026-10-18)
    function focusNear(key, idx) {
      var region = root.querySelector('[data-vor-col-swap="' + key + '"]');
      if (!region) return;
      var t = null;
      if (idx >= 0) {
        var links = region.querySelectorAll('.vor-col__applied a');
        if (links.length) t = links[Math.min(idx, links.length - 1)];
      }
      if (!t) {
        t = drawer && drawer.contains(region) ? drawer.querySelector('.vor-col__dtitle') : root.querySelector('[data-vor-col-swap="results"]');
        if (t) t.setAttribute('tabindex', '-1');
      }
      if (t) t.focus({ preventScroll: true });
    }

    // Section responses can carry section_id in their links; keep real page URLs.
    function cleanLinks() {
      root.querySelectorAll('a[href*="section_id="]').forEach(function (a) {
        var u = new URL(a.href, location.href);
        u.searchParams.delete('section_id');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      });
    }

    function formUrl() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (String(v).trim() === '') return;
        if (k === 'sort_by' && v === root.getAttribute('data-default-sort')) return;
        params.append(k, v);
      });
      var base = root.getAttribute('data-url');
      var q = params.toString();
      return base + (q ? '?' + q : '');
    }

    // Preview keeps its alternate template: a ?view= on the page (e.g. view=vor before launch) stays on every URL
    // the script builds or follows, so a reload or Back lands on the same template. No effect without ?view=.
    var view = new URLSearchParams(location.search).get('view');
    function keepView(url) {
      if (!view) return url;
      var u = new URL(url, location.href);
      if (!u.searchParams.has('view')) u.searchParams.set('view', view);
      return u.pathname + u.search + u.hash;
    }

    function apply(url, push) {
      url = keepView(url);
      if (ctrl) ctrl.abort();
      if (pageCtrl) pageCtrl.abort();
      gen++;
      var c = ctrl = new AbortController();
      var results = root.querySelector('[data-vor-col-swap="results"]');
      if (results) results.setAttribute('aria-busy', 'true');
      var my = pending = getDoc(url, c.signal).then(function (doc) {
        if (c.signal.aborted) return; // a newer request took over after this one had already arrived
        // A Load more clicked while this was loading fetched the old filter's next page: drop it (review 2026-10-18)
        gen++;
        if (pageCtrl) pageCtrl.abort();
        swap(doc);
        if (push !== false) history.pushState({ vorCol: { filter: true } }, '', url);
      }).catch(function (e) {
        if (e && e.name === 'AbortError') return;
        location.href = url; // fall back to a normal page load
      }).then(function () {
        if (pending !== my) return; // an aborted request must not clear the newer one's state
        var r = root.querySelector('[data-vor-col-swap="results"]');
        if (r) r.removeAttribute('aria-busy');
        pending = null;
      });
      return my;
    }

    /* ---------- drawer ---------- */
    function openDrawer(btn) {
      if (!drawer) return;
      opener = btn || null;
      closeDropdowns();
      if (typeof drawer.showModal === 'function') drawer.showModal(); else drawer.setAttribute('open', '');
      document.documentElement.classList.add('vor-col-lock');
    }
    function closeDrawer() {
      if (!drawer || !drawer.open) return;
      if (typeof drawer.close === 'function') drawer.close(); else drawer.removeAttribute('open');
    }
    if (drawer) {
      drawer.addEventListener('close', function () {
        document.documentElement.classList.remove('vor-col-lock');
        var o = opener && document.body.contains(opener) ? opener : root.querySelector('[data-vor-col-open]');
        if (o) o.focus({ preventScroll: true });
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer(); // backdrop
      });
    }

    function scrollToResults() {
      var r = root.querySelector('[data-vor-col-swap="results"]');
      if (!r || !bar) return;
      var top = r.getBoundingClientRect().top + window.scrollY - bar.offsetHeight - (parseInt(getComputedStyle(root).getPropertyValue('--vor-col-top'), 10) || 0);
      if (window.scrollY > top) window.scrollTo(0, Math.max(0, top));
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var done = pending || Promise.resolve();
      done.then(function () {
        closeDrawer();
        scrollToResults();
      });
    });

    /* ---------- desktop dropdowns ---------- */
    function closeDropdowns(except) {
      root.querySelectorAll('[data-vor-col-dd][open]').forEach(function (d) {
        if (d !== except) d.open = false;
      });
    }
    // A panel that would run past the right edge (later dropdowns at 990-1280px) opens right-aligned (review 2026-10-18)
    function fitPanel(d) {
      var p = d.querySelector('.vor-col__dd-panel');
      if (!p) return;
      p.classList.remove('is-flip');
      if (p.getBoundingClientRect().right > document.documentElement.clientWidth - 8) p.classList.add('is-flip');
    }
    root.addEventListener('toggle', function (e) {
      if (e.target.matches && e.target.matches('[data-vor-col-dd]') && e.target.open) {
        closeDropdowns(e.target);
        fitPanel(e.target);
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-vor-col-dd]')) closeDropdowns();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = e.target.closest && e.target.closest('[data-vor-col-dd][open]');
      if (d) {
        e.preventDefault();
        e.stopPropagation();
        var sum = d.querySelector('summary');
        sum.focus();
        d.open = false;
      }
    });

    /* ---------- changes ---------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      t.__vorTyped = false;
      if (t.hasAttribute('data-for')) {
        var twin = document.getElementById(t.getAttribute('data-for'));
        if (!twin) return;
        if (t.type === 'checkbox') twin.checked = t.checked; else twin.value = t.value;
      } else if (!(t.form === form || t.hasAttribute('data-vor-col-sort'))) {
        return;
      }
      var next = formUrl();
      if (new URL(next, location.href).href === location.href) return;
      apply(next);
    });
    // Enter in a price field applies instead of submitting/closing
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.type === 'number') {
        e.preventDefault();
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    root.addEventListener('focusout', function (e) {
      var t = e.target;
      if (t.__vorTyped) t.dispatchEvent(new Event('change', { bubbles: true }));
    });

    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-vor-col-open]');
      if (o) { e.preventDefault(); openDrawer(o); return; }
      if (e.target.closest('[data-vor-col-close]')) { e.preventDefault(); closeDrawer(); return; }
      var l = e.target.closest('a[data-vor-col-link]');
      if (l && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); apply(l.href); return; }
      var m = e.target.closest('a[data-vor-col-more]');
      if (m && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); loadMore(m); return; }
      if (e.target.closest('.vor-col__grid a')) saveState();
    });

    window.addEventListener('popstate', function () {
      if (location.pathname === new URL(root.getAttribute('data-url'), location.href).pathname) apply(location.href, false);
    });

    /* ---------- load more ---------- */
    function grid() { return root.querySelector('[data-vor-col-grid]'); }

    function updateShown() {
      var g = grid();
      var shown = root.querySelector('[data-vor-col-shown]');
      if (!g || !shown) return;
      var from = parseInt(g.getAttribute('data-from'), 10) || 1;
      var total = parseInt(shown.getAttribute('data-total'), 10) || 0;
      var to = from - 1 + g.children.length;
      shown.textContent = total + ' üründen ' + (from > 1 ? from + '–' + to : to) + ' gösteriliyor';
      var bar2 = root.querySelector('.vor-col__progress span');
      if (bar2 && total) bar2.style.width = Math.min(100, Math.round(to * 100 / total)) + '%';
    }

    var pageCtrl = null;
    function appendPage(url) {
      var my = gen;
      if (!pageCtrl || pageCtrl.signal.aborted) pageCtrl = new AbortController();
      return getDoc(url, pageCtrl.signal).then(function (doc) {
        if (my !== gen) return null; // filters or sort changed while this page loaded
        var g = grid();
        var src = doc.querySelector('[data-vor-col-grid]');
        if (!g || !src) return null;
        var page = parseInt(src.getAttribute('data-page'), 10) || 0;
        var have = {};
        Array.prototype.forEach.call(g.children, function (li) { have[li.getAttribute('data-pid')] = 1; });
        var first = null;
        Array.prototype.slice.call(src.children).forEach(function (li) {
          if (have[li.getAttribute('data-pid')]) return;
          g.appendChild(document.importNode(li, true));
          if (!first) first = g.lastElementChild;
        });
        var more = root.querySelector('[data-vor-col-swap="more"]');
        var moreSrc = doc.querySelector('[data-vor-col-swap="more"]');
        if (more && moreSrc) more.innerHTML = moreSrc.innerHTML;
        g.setAttribute('data-page', page);
        cleanLinks();
        root.classList.add('is-extended');
        updateShown();
        return first;
      });
    }

    function loadMore(link) {
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      var my = gen;
      appendPage(link.href).then(function (first) {
        if (my !== gen) return;
        saveState();
        if (first) {
          var a = first.querySelector('a');
          if (a) a.focus({ preventScroll: true });
        }
      }).catch(function () {
        if (my !== gen) return; // aborted by a filter change
        location.href = link.href;
      });
    }

    function saveState() {
      var g = grid();
      if (!g) return;
      var st = Object.assign({}, history.state || {});
      st.vorColMore = { url: location.href, last: parseInt(g.getAttribute('data-page'), 10) || 1, y: Math.round(window.scrollY) };
      try { history.replaceState(st, ''); } catch (e) { /* ignore */ }
    }
    window.addEventListener('pagehide', saveState);

    function restore() {
      var st = history.state && history.state.vorColMore;
      var g = grid();
      if (!st || !g || st.url !== location.href) return;
      var page = parseInt(g.getAttribute('data-page'), 10) || 1;
      if (st.last <= page) return;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var chain = Promise.resolve();
      var base = new URL(location.href);
      var my = gen;
      for (var p = page + 1; p <= st.last; p++) {
        (function (n) {
          chain = chain.then(function () {
            if (my !== gen) return; // a filter change ends the restore
            base.searchParams.set('page', n);
            return appendPage(base.toString());
          });
        })(p);
      }
      chain.then(function () {
        if (my === gen) window.scrollTo(0, st.y);
        history.scrollRestoration = 'auto';
      }).catch(function () { history.scrollRestoration = 'auto'; });
    }
    restore();
  }

  function boot() {
    document.querySelectorAll('[data-vor-col]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  /* The product cards' hover photo is loaded by assets/vor-header.js (every page has the header). */
})();
